import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-screen w-full max-w-3xl flex-col items-start justify-center gap-4 p-6">
      <h1 className="text-3xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-muted-foreground text-sm">
        The page you're looking for doesn't exist.
      </p>
      <div className="flex gap-3">
        <Link className="rounded border px-3 py-1.5 text-sm" to="/">
          Go home
        </Link>
      </div>
    </main>
  );
}
